import axios from 'axios';
import store from './store';

import { USER_START_LOADING, USER_FINISH_LOADING } from './store/actions/user';

//const API_URL = process.env.API_URL || 'http://192.168.1.50:5050'

//const API_URL = process.env.API_URL || 'http://demo.areadecliente.net:5050'
//const API_URL = 'http://illesasesores.areadecliente.net:5050'
//const API_URL = 'http://api.organizacionbonet.es:5050'
//const API_URL = 'https://mayol.areadecliente.net:5050'
const API_URL = 'http://sastreabogados.areadecliente.net:5050'

const http = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
})

http.interceptors.request.use(
    config => {
        store.dispatch(USER_START_LOADING);
        return config;
    }, 
    error => {
        store.dispatch(USER_FINISH_LOADING)
        return Promise.reject(error);
    });

http.interceptors.response.use(
    response => {
        store.commit(USER_FINISH_LOADING);
        return response;
    }, 
    error => {
        store.commit(USER_FINISH_LOADING);
        return Promise.reject(error);
    });

export default http